import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import PageHero from "../components/PageHero";
import CTABanner from "../components/CTABanner";
import { SectionLabel } from "../components/Shared";
import { PRICING_PLANS, IMAGES } from "../config/siteConfig";
import { stagger, fadeUp, viewportOnce } from "../lib/motion";

export default function PricingPage() {
  return (
    <>
      <PageHero
        label="Pricing"
        title="Pricing"
        highlight="Plans."
        subtitle="Managed website services and mobile app development plans designed for businesses that want to go live and stay supported."
        image={IMAGES.employers}
      />
      <section className="bg-[#F7F7F5] py-24 md:py-36" data-testid="pricing-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionLabel>Plans</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight text-[#111111] mb-12">
            Choose a plan that fits your <span className="text-[#C62828]">product.</span>
          </h2>
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="grid md:grid-cols-3 gap-6"
          >
            {PRICING_PLANS.map((plan) => (
              <motion.div
                key={plan.id}
                variants={fadeUp}
                data-testid={`pricing-${plan.id}`}
                className={`rounded-sm p-8 border ${
                  plan.featured
                    ? "bg-[#111111] text-white border-[#C62828]"
                    : "bg-white text-[#111111] border-black/10"
                }`}
              >
                <p className={`overline text-[10px] mb-4 ${plan.featured ? "text-[#E03535]" : "text-[#C62828]"}`}>
                  {plan.featured ? "Popular" : "Plan"}
                </p>
                <h3 className="font-body font-600 text-xl mb-4 leading-snug">{plan.title}</h3>
                <p className="font-display text-4xl mb-1">
                  {plan.price}
                  <span className={`text-base font-body ml-2 ${plan.featured ? "text-white/60" : "text-[#555]"}`}>
                    {plan.period}
                  </span>
                </p>
                <ul className="mt-8 space-y-3">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 font-body text-sm">
                      <Check size={16} className={`mt-0.5 flex-shrink-0 ${plan.featured ? "text-[#E03535]" : "text-[#C62828]"}`} />
                      <span className={plan.featured ? "text-white/75" : "text-[#555]"}>{f}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
      <CTABanner heading="Have a custom requirement?" highlight="Let's talk." />
    </>
  );
}
